import { RadioTheme, styles, variants } from '../RadioStyles.css';
import { baseTheme } from './RadioBaseTheme.css';
import { multiVariantStyles } from './RadioVariants.css';

/*******************
 * Component Theme
 *******************/

const RadioStableTheme: RadioTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { RadioStableTheme };
